import { Constants } from '@homegauge/vue';
import Api from '@/api';

import state from './state';

/**
 * @TODO remove when error envelope is put into effect (https://homegauge.atlassian.net/browse/WEB-4035)
 *
 * Convert legacy error to standard error envelope
 * @param {object} legacyError
 * @returns {object} Standardized error envelope
 */
const convertLoadAppointmentLegacyError = legacyError => {
  if (legacyError.body) {
    return legacyError;
  }

  const output = {
    success: false,
    body: {
      message: 'Appointment could not be retrieved',
      fieldViolations: [],
    },
  };

  if (legacyError.message) {
    output.body.message = legacyError.message;
  }

  if (legacyError.errors) {
    output.body.fieldViolations.push({
      field: 'error',
      messages: legacyError.errors.map(error => error.message),
    });
  }

  return output;
};

const loadAppointment = (context, appointmentId) => new Promise((resolve, reject) => {
  Api.appointmentService.getAppointment(appointmentId)
    .then(response => {
      context.commit('setBookingData', response.data);
      resolve(response.data);
    })
    .catch(error => {
      const errorResponse = convertLoadAppointmentLegacyError(error.data);
      reject(errorResponse);
    });
});

const loadServicesEstimate = async context => {
  context.commit('setEstimateError', null);
  context.commit('setEstimateLoading', true);

  const requestData = {
    invoiceItems: context.state.servicesComponentData.selectedServices
      .map(selectedService => ({
        quantity: selectedService.quantity || 1,
        serviceId: selectedService.id,
      })),
  };

  try {
    const servicesEstimate = await Api.invoiceService
      .postServicesEstimate(requestData);
    context.commit('setEstimate', servicesEstimate.data);
  } catch (err) {
    context.commit('setEstimateError', err);
  }
  context.commit('setEstimateLoading', false);
};

const setBookingData = (context, data) => context.commit('setBookingData', data);

const setDate = (context, data) => context.commit('setDate', data);

const setEmail = (context, data) => context.commit('setEmail', data);

const setLocation = (context, data) => context.commit('setLocation', data);

const resetBookingData = context => context.commit('setBookingData', state.bookingData);

const resetDate = context => context.commit('setDate', state.dateComponentData);

const resetEmail = context => context.commit('setEmail', state.emailComponentData);

const resetLocation = context => context.commit('setLocation', state.locationComponentData);

const resetReachedSummary = context => context.commit('setReachedSummary', state.reachedSummary);

const saveRequest = (context, companyId) => new Promise(async (resolve, reject) => {
  context.commit('setBookingLoading', true);

  try {
    const request = context.getters.buildScheduleRequest;
    const response = await Api.appointmentService.postRequest(companyId, request);
    await Promise.all([
      context.dispatch('setBookingData', response.data),
      context.dispatch('resetDate'),
      context.dispatch('resetLocation'),
      context.dispatch('resetEmail'),
      context.dispatch('resetReachedSummary'),
      context.dispatch('resetServices'),
      context.dispatch('resetServicesEstimate'),
      context.dispatch('setContact', null),
    ]);
    resolve(response.data);
  } catch (err) {
    if (err.status === Constants.HttpStatusCodes.Conflict) {
      context.commit('setTimeUnavailable', true);
    } else {
      context.commit('setApiError', true);
    }
    reject(err.data);
  }

  context.commit('setBookingLoading', false);
});

const addService = (context, service) => context.commit('addService', service);

const removeService = (context, serviceId) => context.commit('removeService', serviceId);

const resetServices = context => context.commit('setServices', state.servicesComponentData.selectedServices);

const resetServicesEstimate = context => context.commit('setEstimate', state.servicesComponentData.estimate);

const setServices = (context, data) => context.commit('setServices', data);

const loadAppointmentInvoices = (context, appointmentId) => new Promise(
  (resolve, reject) => Api.invoiceService
    .getInvoicesForAppointment(appointmentId)
    .then(res => resolve(res.data))
    .catch(err => reject(err)),
);

const setContact = (context, contact) => context.commit('setContact', contact);
const setContactRole = (context, contactRole) => context.commit('setContactRole', contactRole);

const loadCustomFields = (context, companyId) => new Promise((resolve, reject) => {
  Api.appointmentCustomFieldsService.getCustomFields(companyId)
    .then(response => {
      context.commit('setCustomFields', response.data.customFieldDefinitions);
      resolve(response.data);
    })
    .catch(error => {
      reject(error);
    });
});

const setCustomFields = (context, customFields) => context.commit('setCustomFields', customFields);

export { convertLoadAppointmentLegacyError };
export default {
  loadAppointment,
  loadAppointmentInvoices,
  loadServicesEstimate,
  resetBookingData,
  resetDate,
  resetEmail,
  resetLocation,
  resetReachedSummary,
  saveRequest,
  setBookingData,
  setDate,
  setEmail,
  setLocation,
  addService,
  removeService,
  resetServices,
  resetServicesEstimate,
  setServices,
  setContact,
  setContactRole,
  loadCustomFields,
  setCustomFields,
};
